<ng-container rtBlock="sc-catalog-list-page">
    <sc-page-header qa-dataid="catalog-header">
        <h1 slot="title" i18n="@@breadcrumbCatalog">Каталог</h1>
        <p slot="lead" rtElem="lead" i18n="@@catalogListLead">Породы дерева, покрытия, ограждения и подсветка.</p>
    </sc-page-header>

    <section rtElem="frame">
        <ul rtElem="grid">
            @for (catalogItem of items; track catalogItem.slug) {
                <li rtElem="card">
                    <h2 rtElem="card-label">{{ catalogItem.label }}</h2>
                    <p rtElem="card-text">
                        <span i18n="@@catalogCardDensityPrefix">Плотность около</span>
                        {{ catalogItem.density }}
                        <span i18n="@@catalogCardDensityUnit">кг/м³.</span>
                        {{ catalogItem.text }}
                    </p>
                    <a
                        rtElem="card-link"
                        qa-dataid="catalog-card"
                        [attr.data-slug]="catalogItem.slug"
                        [routerLink]="['/catalog', catalogItem.slug]">
                        <span aria-hidden="true">→</span>
                        <span i18n="@@catalogCardMore">Подробнее</span>
                    </a>
                </li>
            }
        </ul>
    </section>
</ng-container>
